import { v4 as uuidV4 } from 'uuid';
import { isNullOrUndefined, isSMAManagerFeeExcluded } from '../../../../utils/utils';
import { isHistoricManagerFee } from '../../../shared/shared-advisory-fee-helpers';

export default {
  props: {
    managerFee: Number,
    historicManagerFee: Array,
  },
  computed: {
    isHistoricManagerFee() {
      return isHistoricManagerFee(this.historicManagerFee);
    },
    currentFeeScheduleId() {
      return uuidV4();
    },
  },
  methods: {
    getManagerFee(managerFee, feeSchedule) {
      if (isNullOrUndefined(managerFee) || !isSMAManagerFeeExcluded(feeSchedule)) {
        return 0;
      }
      return managerFee;
    },
  },
};
